module.exports = __webpack_public_path__ + "static/6-2de1f685af26b40a61397b87a717bc7e.png";